const state = {
  showLoaderOverlay: false,
  meetingDetails: {},
  isLoginLoading: false,
};

export default state;
